import { graphql, useStaticQuery } from "gatsby";

const getAllNews = () => useStaticQuery(graphql`
    {
      allKontentItemArticlePageNews(sort: {elements: {publishdate: {value: DESC}}}) {
        nodes {
          ...NewsCard
        }
      }
      allKontentItemArticleMigration(sort: {elements: {publishdate: {value: DESC}}}) {
        nodes {
          ...NewsCardMigrated
        }
      }
      allKontentItemArticlePress(sort: {elements: {publishdate: {value: DESC}}}) {
        nodes {
          ...NewsCardPress
        }
      }
    }
  `);

export default getAllNews;
